import { render, staticRenderFns } from "./Utilizations.vue?vue&type=template&id=2ad347fc&scoped=true"
import script from "./Utilizations.js?vue&type=script&lang=js&external"
export * from "./Utilizations.js?vue&type=script&lang=js&external"
import style0 from "./Utilizations.scss?vue&type=style&index=0&id=2ad347fc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad347fc",
  null
  
)

export default component.exports